import { render, staticRenderFns } from "./AddDivision.vue?vue&type=template&id=2d709452&scoped=true&"
import script from "./AddDivision.vue?vue&type=script&lang=js&"
export * from "./AddDivision.vue?vue&type=script&lang=js&"
import style0 from "./AddDivision.vue?vue&type=style&index=0&id=2d709452&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d709452",
  null
  
)

export default component.exports